var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7817_13387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.269531C3.58 0.269531 0 3.84953 0 8.26953C0 12.6895 3.58 16.2695 8 16.2695C12.42 16.2695 16 12.6895 16 8.26953C16 3.84953 12.42 0.269531 8 0.269531ZM8 1.26953C11.86 1.26953 15 4.40953 15 8.26953C15 9.22953 14.8 10.1495 14.45 10.9895L10.77 7.10953L6.8 11.0795L5.03 9.30953L2.27 12.2895C1.47 11.1495 1 9.76953 1 8.27953C1 4.41953 4.14 1.27953 8 1.27953V1.26953ZM8 15.2695C5.99 15.2695 4.19 14.4195 2.91 13.0595L5.06 10.7495L6.81 12.4995L10.76 8.54953L13.97 11.9295C12.74 13.9295 10.53 15.2695 8.01 15.2695H8Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.82953C6.88 7.82953 8 6.70953 8 5.32953C8 3.94953 6.88 2.82953 5.5 2.82953C4.12 2.82953 3 3.94953 3 5.32953C3 6.70953 4.12 7.82953 5.5 7.82953ZM5.5 3.82953C6.33 3.82953 7 4.49953 7 5.32953C7 6.15953 6.33 6.82953 5.5 6.82953C4.67 6.82953 4 6.15953 4 5.32953C4 4.49953 4.67 3.82953 5.5 3.82953Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7817_13387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "",
    transform: "translate(0 0.269531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.1d7c821846408230fa8b12ba09741fdf.svg";
export { ForwardRef as ReactComponent };